export const LOGIN_SUCCEEDED = 'Auth/LOGIN_SUCCEEDED';
export const LOGIN_ERROR = 'Auth/LOGIN_ERROR';
export const INVALID_EMAIL = 'Auth/INVALID_EMAIL';
export const CLEAR_AUTH = 'Auth/CLEAR';
export const INVALID_PASSWORD = 'Auth/INVALID_PASSWORD';
export const LOGOUT_SUCCEEDED = 'Auth/LOGOUT_SUCCEEDED';
export const SIGNUP_SUCCEEDED = 'Auth/SIGNUP_SUCCEEDED';
export const SIGNUP_ERROR = 'Auth/SIGNUP_ERROR';
export const LOADING_STATE = 'Auth/LOADING_STATE';
export const UNVERIFIED_EMAIL_ERROR = 'Auth/UNVERIFIED_EMAIL_ERROR';
export const RESET_PASSWORD_SUCCEEDED = 'Auth/RESET_PASSWORD_SUCCEEDED';
export const RESET_PASSWORD_FAILED = 'Auth/RESET_PASSWORD_ERROR';
export const GET_GYMS_SUCCEEDED = 'Gyms/GET_GYMS_SUCCEEDED';
export const GET_GYMS_ERROR = 'Gyms/GET_GYMS_ERROR';
